import { TFunction } from 'react-i18next';
import { ValidationOptions } from '../../../../types/form';
import { isDateValid } from '../../../../helpers/dates';

export function applyDateValidationOptions<TFieldValues>(
  t: TFunction,
  rules: ValidationOptions<TFieldValues> = {},
) {
  rules.validate = {
    validateDate: (value) => {
      const date = value as string;

      if (date && !isDateValid(date)) {
        return t('site.pricing.validation.error.code.INVALID_DATE');
      }
    },

    ...rules.validate,
  };

  return rules;
}
